(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-form"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.custom-lang-dropdown').forEach(function(dropdown) {
  var button = dropdown.querySelector('.custom-lang-dropdown__button');
  var list = dropdown.querySelector('.custom-lang-dropdown__list');
  var select = dropdown.closest('.language-selector').querySelector('select[name="language_code"]');
  var closeTimer;

  button.addEventListener('mouseenter', function() {
    clearTimeout(closeTimer);
    button.setAttribute('aria-expanded', 'true');
    list.hidden = false;
  });

  list.addEventListener('mouseenter', function() {
    clearTimeout(closeTimer);
  });

  dropdown.addEventListener('mouseleave', function() {
    closeTimer = setTimeout(function() {
      list.hidden = true;
      button.setAttribute('aria-expanded', 'false');
    }, 150);
  });

  dropdown.querySelectorAll('.custom-lang-dropdown__item').forEach(function(item) {
    item.addEventListener('click', function() {
      select.value = item.dataset.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      list.hidden = true;
      button.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('click', function(e) {
    if (!dropdown.contains(e.target)) {
      list.hidden = true;
      button.setAttribute('aria-expanded', 'false');
    }
  });
});
  } catch(e) { console.error(e); }
})();

})();
